import React from "react";
import styled from "@emotion/styled";

const LineItem = styled.p`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #777984;
  margin-bottom: 2px;

  @media (max-width: 385px) {
    font-size: 13px;
  }
`;

const CapitalizeLineItem = styled(LineItem)`
  text-transform: capitalize;
`;

const BankAccountDisplay = ({ account_type, account, routing }) => (
  <div>
    <CapitalizeLineItem>{account_type} account</CapitalizeLineItem>
    <LineItem>Account #: {account}</LineItem>
    <LineItem>Routing #: {routing}</LineItem>
  </div>
);

export default BankAccountDisplay;
